import { Component, OnInit } from '@angular/core';
import { GamesGroupService, IPollQuestion, PopulationQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrl: './polls-page.component.scss',
})
export class PollsPageComponent implements OnInit {
  pollsQuestion$: Observable<IPollQuestion[]>;
  populations = Populations;
  isCorporate: boolean;

  constructor(
    private gamesGroupService: GamesGroupService,
    private populationQuery: PopulationQuery
  ) {}

  ngOnInit(): void {
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }
}
